import React from "react";
import { Helmet } from "react-helmet-async";
import { useTranslation } from "react-i18next";
import { SITE_BASE_URL } from "./constants/urls";

export const Noindex = ({ routeKey = "privacyPolicy" }) => {
  const { i18n } = useTranslation();
  const enPath = i18n.getFixedT("en", "routes")(routeKey);
  const frPath = i18n.getFixedT("fr", "routes")(routeKey);

  return (
    <Helmet>
      <meta name="robots" content="noindex" />
      <link rel="alternate" hreflang="en" href={`${SITE_BASE_URL}${enPath}`} />
      <link rel="alternate" hreflang="fr" href={`${SITE_BASE_URL}${frPath}`} />
    </Helmet>
  );
};
